module.exports = __webpack_public_path__ + "static/media/Al-Thiqa Pharmacy uses Curoflow Telemedicine platform.56907043.webp";